<div id="device-detail-summary tw-items-baseline">
  <div class="tw-flex tw-items-center tw-min-w-[1200px]">
    @if (deviceHistoryFormGroup && shipmentHistoryFormGroup) {
      <mat-button-toggle-group
        class="matp-button-toggle-group matp-button-inactive"
        aria-label="デバイスと配送切り替え"
        [hideSingleSelectionIndicator]="'true'"
        [(ngModel)]="selectedDisplayPage"
        name="selectPage"
        (click)="displayPageChanged.emit(selectedDisplayPage)"
      >
        <mat-button-toggle class="tw-w-[178px]" value="device"
          >デバイス</mat-button-toggle
        >
        <mat-button-toggle class="tw-w-[178px]" value="shipment"
          >配送</mat-button-toggle
        >
      </mat-button-toggle-group>

      <div class="tw-ml-4">
        @if (selectedDisplayPage === "device") {
          <app-datetime-range-picker
            [formGroup]="deviceHistoryFormGroup"
            startFormControlName="historyFrom"
            endFormControlName="historyTo"
          ></app-datetime-range-picker>
          @if (
            deviceHistoryFormGroup.controls["historyFrom"].errors?.[
              "dateTooEarly"
            ]
          ) {
            <mat-error class="tw-text-xs">
              期間は直近２か月以内で指定してください。
            </mat-error>
          }
          @if (
            deviceHistoryFormGroup.controls["historyFrom"].errors?.[
              "dateBeforeCreation"
            ]
          ) {
            <mat-error class="tw-text-xs">
              期間はテナント作成日時
              {{ tenantCreatedAt | date: "yyyy/MM/dd HH:mm" }}
              より後の日時を指定してください。
            </mat-error>
          }
        } @else if (selectedDisplayPage === "shipment") {
          <app-datetime-range-picker
            [formGroup]="shipmentHistoryFormGroup"
            startFormControlName="historyFrom"
            endFormControlName="historyTo"
          ></app-datetime-range-picker>
        }
      </div>

      <div class="tw-ml-4">
        <button
          mat-raised-button
          id="search-btn"
          class="tw-text-lg tw-mx-2"
          color="primary"
          [disabled]="
            deviceHistoryFormGroup.invalid || shipmentHistoryFormGroup.invalid
          "
          (click)="historyFiltered.emit()"
        >
          <mat-icon>search</mat-icon>
          <span>検索</span>
        </button>
      </div>
    }
  </div>

  @if (selectedDisplayPage === "device") {
    <div class="tw-my-4 tw-min-w-[1005px]">
      <mat-button-toggle-group
        name="toggle"
        class="matp-button-toggle-group !tw-flex tw-gap-x-2 tw-items-stretch !tw-overflow-x-auto !tw-border-0"
        [hideSingleSelectionIndicator]="'true'"
        [(ngModel)]="selectedBtn"
        (change)="onSensingBtnChanged($event)"
      >
        @for (option of summaryBtnOptions; track option.key) {
          <mat-button-toggle
            [value]="option.key"
            class="tw-flex-1 tw-flex tw-items-center !tw-border !tw-border-solid !matp-border-default tw-min-w-40 tw-py-[0.6rem]"
            [disabled]="disabled || !isExist(option.key, option.type)"
          >
            <div class="tw-flex tw-leading-normal">
              <div class="tw-flex tw-flex-col tw-relative">
                <!-- アイコン -->
                <div class="tw-flex">
                  <mat-icon class="tw-text-4xl !tw-h-9 !tw-w-9 tw-leading-9">
                    {{ option.iconName }}
                  </mat-icon>
                </div>

                <!-- アラート表示 -->
                <div class="tw-absolute tw-top-4 tw-left-5">
                  @if (getSensingStatus(option.key, option.type) === "Alert") {
                    <mat-icon class="tw-text-red-500">error</mat-icon>
                  } @else if (
                    getSensingStatus(option.key, option.type) === "PreAlert"
                  ) {
                    <mat-icon class="tw-text-yellow-500">warning</mat-icon>
                  }
                </div>

                <!-- ラベル -->
                <div>{{ option.label }}</div>
              </div>
            </div>
          </mat-button-toggle>
        }
      </mat-button-toggle-group>
    </div>
  }
</div>
